const getTypography = (size: number, lineHeight: number) => {
  return {
    fontSize: size,
    lineHeight: lineHeight,
  };
};

export const fontStylesByVariant = {
  huge: getTypography(80, 80),
  h1: getTypography(60, 60),
  h2: getTypography(36, 48),
  h3: getTypography(28, 36),
  h5: getTypography(24, 32),
  body: getTypography(16, 22),
  small: getTypography(16, 22),
  tiny: getTypography(13, 20),
  micro: getTypography(12, 18),
};

export const fontStylesByVariantMobile = {
  ...fontStylesByVariant,
  huge: getTypography(40, 48),
  h1: getTypography(32, 40),
  h2: getTypography(24, 32),
  body: getTypography(12, 14),
};

export const storiesArgTypes = {
  variant: {
    // This is an abstraction object we use in TypographyComponent
    // in order to compute styles, so in case you add some more variants
    // the only thing you should do is add another property to fontStylesByVariant
    options: Object.keys(fontStylesByVariant),
    control: { type: 'select' },
  },
  fontWeight: {
    options: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    control: { type: 'select' },
  },
  component: {
    options: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p'],
    control: { type: 'select' },
  },
  responsiveBreakpoint: {
    options: ['sm', 'md', 'lg', null],
    control: { type: 'select' },
  },
};

export type FontVariants = keyof typeof fontStylesByVariant;
